import { Icon } from '@innovationnorway/cl-react';
import React from 'react';
import '../../styles/OneWayInStyle.scss';
import { OneWayInOpportunitySimpleV2Dto, OneWayInOpportunityStatusDto } from 'src/api/v2';
import { formatDateToNOString } from 'src/utils/FormatValue';
import '../../../../styles/style.scss';
import OneWayInNoteListBody from './OneWayInNoteListBody';
type Props = {
  opportunity: OneWayInOpportunitySimpleV2Dto;
};
const StatusIcon = ({ status }: { status: OneWayInOpportunityStatusDto | undefined }) => {
  if (status?.description?.length)
    return <Icon prefix="fasr" iconName="check-circle" size="l" className="color--in-green-200" />;
  return <Icon prefix="fasr" iconName="square-info" size="l" />;
};
const OneWayInNoteListItem: React.FC<Props> = ({ opportunity }) => {
  const [expanded, setExpanded] = React.useState<boolean>(false);
  const toggleVisibility = () => {
    setExpanded((isExpanded) => !isExpanded);
  };
  return (
    <div className="opportunity-card margin-top--2">
      <button className="display--flex clickable-wrapper item-wrapper gap--4" onClick={toggleVisibility}>
        <StatusIcon status={opportunity.status} />
        <div className="stack-medium width--100">
          {opportunity.submittedOn &&
            formatDateToNOString(opportunity.submittedOn, false, '{date}.{month}.{year}', true)}
          <div className="opportunity-card__title">{opportunity.title}</div>
          {opportunity.status?.description && <div>{opportunity.status.description}</div>}
        </div>
        <Icon prefix="fasr" iconName={expanded ? 'chevron-up' : 'chevron-down'} className="margin--auto" />
      </button>
      <div>{expanded && <OneWayInNoteListBody opportunity={opportunity} />}</div>
    </div>
  );
};
export default OneWayInNoteListItem;
